module.exports = __webpack_public_path__ + "img/bo.35fdb669.svg";